// import useFacebookAuthentication from "./useFacebookAuthentication";
import useGoogleAuthentication from "./useGoogleAuthentication";

const useSocialLogin = () => {
  const { googleUser, handleGoogleBtnClick, isGoogleLoading } =
    useGoogleAuthentication();
  // const { facebookUser, handleFacebookLogin } = useFacebookAuthentication();
  const handleSocialLogin = (type: "google" | "facebook") => {
    switch (type) {
      case "google":
        handleGoogleBtnClick();
        break;
      // case "facebook":
      //   handleFacebookLogin();
      //   break;
      default:
        handleGoogleBtnClick();
        break;
    }
  };

  return {
    socialUser: googleUser ? googleUser : null,
    handleSocialLogin,
  };
};

export default useSocialLogin;
